<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'Blank',
  data() {
    return {
      menuVisible: false,
      pictureUrl: "",
      history: [],
      code:"",
    }
  },
}
</script>

<style lang="scss" scoped>
  .md-app {
    height: 500px;
    border: 1px solid rgba(#000, .12);
  }
  .md-toolbar.md-theme-default.md-primary {
     background-color: #000;
  }
  .md-content.md-theme-default {
    background-color: #000;
  }
   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-card.md-theme-default {
    background-color: #000;
    background-color: var(--md-theme-default-background, #000);
  }
</style>
<style>
.md-table-content {
    background-color: #000 !important;
    background-color: var(--md-theme-default-background, #000) !important;
 }
 .md-app-scroller {
   background-color: #000 !important;
 }
 .md-table .md-table-head-text,
.md-table .md-table-cell .md-table-cell-container {
  padding-right: 5;
  padding-left: 0;
}
.fontnew{
  font-size: 14px;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  padding: 25px 5px 5px 5px;
}
</style>